"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setUpWindowsEnvironment = void 0;
const core = __importStar(require("@actions/core"));
const child_process_1 = require("child_process");
const fs_1 = require("fs");
// Keep in sync with https://github.com/actions/virtual-environments
const KNOWN_VISUAL_STUDIO_INSTALLATIONS = [
    'C:\\Program Files (x86)\\Microsoft Visual Studio\\2017\\Enterprise',
    'C:\\Program Files (x86)\\Microsoft Visual Studio\\2019\\Enterprise',
    'C:\\Program Files\\Microsoft Visual Studio\\2022\\Enterprise' // 'windows-2022'
];
const VCVARSALL_SUBPATH = '\\VC\\Auxiliary\\Build\\vcvarsall.bat';
function findVcvarsallPath() {
    for (const installation of KNOWN_VISUAL_STUDIO_INSTALLATIONS) {
        const candidate = `${installation}${VCVARSALL_SUBPATH}`;
        if ((0, fs_1.existsSync)(candidate)) {
            return candidate;
        }
    }
    throw new Error('Failed to find vcvarsall.bat');
}
function setUpWindowsEnvironment() {
    core.startGroup('Updating Windows environment...');
    const vcvarsallPath = findVcvarsallPath();
    core.debug(`Calling "${vcvarsallPath}"...`);
    const [originalEnv, vcvarsallOutput, updatedEnv] = (0, child_process_1.execSync)(`set && cls && "${vcvarsallPath}" x64 && cls && set`, { shell: 'cmd' })
        .toString()
        .split('\f'); // form feed page break (printed by `cls`)
    core.debug(vcvarsallOutput);
    const originalEnvMap = new Map();
    for (const line of originalEnv.split('\r\n')) {
        if (line.includes('=')) {
            const [name, value] = line.split('=');
            originalEnvMap.set(name, value);
        }
        else if (line) {
            core.debug(`Skipping ${line} (does not include '=')...`);
        }
    }
    for (const line of updatedEnv.split('\r\n')) {
        if (line.includes('=')) {
            const [name, value] = line.split('=');
            const originalValue = originalEnvMap.get(name);
            if (value !== originalValue) {
                core.exportVariable(name, value);
                core.debug(`"${name}" set to "${value}"`);
            }
        }
        else if (line) {
            core.debug(`Skipping ${line} (does not include '=')...`);
        }
    }
    core.endGroup();
}
exports.setUpWindowsEnvironment = setUpWindowsEnvironment;
